export default __webpack_public_path__ + "static/media/2504271.8b99e0a7.jpg";